export default Object.freeze({
    requestPushNotificationPermission: 'request-push-notification-permission',
    requestBiometricAuthentication: 'request-biometric-authentication',
    requestSubscriptionSelection: 'request-subscription-selection',
})
